var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{attrs:{"type":"is-warning","has-icon":""}},[_vm._v("\n    This is the GW2Scratch.Economics version, which is work in progress.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }